import MobileDeviceProtection from 'partial/OfferManager/modules/CashPerks/MobileDeviceProtection/MobileDeviceProtection';
export default MobileDeviceProtection;
